function hidePagination() {
  const pagination = document.querySelector(".pagination");
  if (pagination) {
    //pagination.style.display = "none";
    const wrapper = pagination.parentElement;
    if (wrapper) {
      wrapper.hidden = true;
    }
  }
}
/** Necesario al quitar el paginador y simular scroll infinito para simular la ñapa
 * que hace la plantilla de añadir elementos al final para ver la última fila blanca */
function updatePlaceholder() {
  const grid = document.querySelector("#CollectionProductGrid .collection-list");

  const allItems = [...grid.children];
  const realItems = allItems.filter(li => !li.hasAttribute("aria-hidden"));

  const productsPerRow = 3; // ⚠️ mismo valor que en Shopify
  const gridCols = 12;

  const remainder = realItems.length % productsPerRow;

  // eliminar placeholders existentes
  grid.querySelectorAll('[aria-hidden="true"]').forEach(el => el.remove());

  if (remainder !== 0) {
    const colSpan = gridCols / productsPerRow;
    const missingItems = productsPerRow - remainder;
    const placeholderWidth = missingItems * colSpan;

    const placeholder = document.createElement("li");
    placeholder.setAttribute("aria-hidden", "true");
    placeholder.setAttribute("role", "presentation");

    placeholder.className =
      "none absolute lg:static lg:block lg:col-span-" +
      placeholderWidth +
      " bg-scheme-background";

    grid.appendChild(placeholder);
  }
}

document.addEventListener("DOMContentLoaded", function () {
    hidePagination();
  let loading = false;
  let currentPage = new URLSearchParams(window.location.search).get("page") || 1;
  currentPage = parseInt(currentPage, 10);

  let hasMore = true;

  async function loadMore() {
    if (loading || !hasMore) return;

    loading = true;
    const nextPage = currentPage + 1;

    const url = new URL(window.location.href);
    url.searchParams.set("page", nextPage);

    console.log("Loading page:", nextPage);

    const response = await fetch(url.toString());

    if (!response.ok) {
      loading = false;
      hasMore = false;
      return;
    }

    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newGrid = doc.querySelector("#CollectionProductGrid .collection-list");
    const currentGrid = document.querySelector("#CollectionProductGrid .collection-list");

    if (!newGrid || !newGrid.children.length) {
      hasMore = false;
      loading = false;
      return;
    }

    const newItems = [...newGrid.children].filter(
      li => !li.hasAttribute("aria-hidden")
    );

    if (!newItems.length) {
      hasMore = false;
      loading = false;
      return;
    }

    newItems.forEach(item => currentGrid.appendChild(item));
    updatePlaceholder();

    const nextPagination = doc.querySelector(".pagination");
    if (!nextPagination) {
      hasMore = false;
    }

    currentPage = nextPage;
    loading = false;
  }

  window.addEventListener("scroll", function () {
    if (!hasMore) return;

    const scrollBottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 600;

    if (scrollBottom) {
      loadMore();
    }
  });
});